
import axiosServices from '@/services/axiosServices.js'

export default {
  props: {
    value: {},          // Donde se Recibe el valor a guardar o guardado respuesta
    aData: {},          // Informacion a mostrar
    titulo: {},         // Pregunta a realizar == Titulo
    id: {},             // HAce referencia al ID del la pregunta dentro de la tabla de fomulario o detalle_form segun corresponda la estructura  - el el autoincremntal
    idPregunta: {},     // id de la pregunta que se esta mostrando como titulo
    idTipoCampo: {},    // Indica el tipo de campo es un numero
    idGrupo: {},        // Indica el id del grupo de a pregunta
    Obligatorio: {},    // Incia si el elemento es obligatorio o no
    ModificaA: {},      // Indica a que campo modifica este valor - se usa para los select fundamentalmente.
    error: {},          // Se emplea para indicar que existe un error y pone en rojo el titulo del campo, en especial cuando es obligatorio y no se llena
    bSubdominioTemporal:{       // Indica que se activa puente con subdominio temporal y debo pasar el param de pueste
      type: Boolean,             
      default: false            
    },
    bDeshabilitado: {
      typeof: Boolean,
      default: false
    }

  },
  data () {
    return {
      selectValue: this.value || null,
      aOptions: [],
      bCargando : false,
      textoInicial : '',   // se emplea para trabajar los campos select y otros que requiere id solo pero debo llenar el textoRepuesta para tener todo ok
    }
  },
  mounted () {
    if(this.value != undefined &&  Object.keys(this.value).length > 0){
      switch(this.value.TipoPregunta){
        case '1':
        case '2':
        case '5':
        case '11':
          this.selectValue = this.value.ValorRespuesta
          this.textoInicial = this.value.TextoRespuesta
        break
        case '4':
          this.aValue = this.getIDs_Multiselect(this.value.Detalle)
        break
        case '6':
          if(!Array.isArray(this.selectValue)){
            this.selectValue = []
            // console.log('MontandoMixin Dinamicos mounte 6 Selectvalue a Array', this.value, )
        }
          // console.log('MontandoMixin Dinamicos mounte 6 value', this.value, )
          // como la info esta en this.value.Detalle lo recorro e invoco salvar por cada areglo que tenga.
          this.value.Detalle.forEach( info => {
            this.subitems.push({...info})
            this.selectValue.push({...info})
          })


        break
        case '7':
        case '9':
          this.selectValue = this.value.TextoRespuesta
        break
        case '8':
          this.sSoloLetras = this.value.TextoRespuesta
        break
        case '10':
          this.date = this.value.TextoRespuesta
        break
        case '3':
          this.aFotos = this.value.Detalle
        break
        case '12':
          this.aFirmas = this.value.Detalle
        break
        case '14':
          this.selectValue = this.value.Detalle
        break
        case '13':
        case '15':
        break
      }
    }

  },
  methods: {
    async CargarData(){
      let aRespuesta = []
      let nPagina = 1
      let nTotalPaginas = 1
      let axiosPreguntasvalor
      this.bCargando = true

      while (nPagina <= nTotalPaginas) {
        let sParams = `app=WEBGesDoc&pagina=${nPagina}&tabla=${this.aData}`
        if(this.bSubdominioTemporal){
          sParams = sParams + `&subdominiot=${this.$store.state.sSubdominioTemporal}`
        }
        axiosPreguntasvalor = await axiosServices.getConfiguration('/formularios-dinamicos/preguntas/valores', true, sParams)
        aRespuesta.push(axiosPreguntasvalor.aData.aData)
        nTotalPaginas = parseInt(axiosPreguntasvalor.aData.nPagina)
        nPagina++
      }

       this.aOptions = aRespuesta.flat()
       this.bCargando = false
    },
    getIDs_Multiselect(aValues){
      let aux_ = []
      aValues.forEach(elemento => aux_.push(elemento.IdRespuesta))
      return aux_
    }
  },
  computed: {
    Texto() {
      let texto = null

      switch (this.idTipoCampo) {
        case '1':
        case '2':
        case '3':
        case '4':
        case '11':
          if(this.aOptions.length > 0) {
            texto = this.selectValue != undefined ? this.aOptions.find( elemento => elemento.ID == this.selectValue).DatoMostrar : ''
          }  else {
            texto = this.textoInicial
          }
        break;
        default:
          texto = this.selectValue
        break;
      }
      return texto
    },
    Valor() {
      let valor = null

      switch (this.idTipoCampo) {
        case '1':
        case '2':
        case '3':
        case '4':
        case '11':
          valor = this.selectValue != undefined ? this.selectValue : ''
        break;
        default:
          valor = ""
        break;
      }

      return valor
    },

  },
  watch: {
    // todos los componentes cambia la Variable selectValue con el valor que se les llena por esto la monitoreo y ante su cambio se genera la estructura para la respuesta
    selectValue (newSelectValue, oldSelecValue) {

      // console.log('En mixin dinamicos watch inicio',this.idTipoCampo, newSelectValue)
      let aDetall = []      // Variable para armar array de respuestas detalle


      switch (this.idTipoCampo) {
        case '2':
          if (newSelectValue !== null || newSelectValue !== undefined) {
            this.$emit('input',
              {
                IdGrupo : this.idGrupo,
                IdPregunta : this.idPregunta,
                TextoRespuesta : this.Texto,
                ValorRespuesta : this.Valor,
                TipoPregunta : this.idTipoCampo,
                Titulo : this.titulo,
              }
            )
          }
          this.$store.dispatch('dinamicos/pushaModificaA',{idPregunta : this.ModificaA , valor: this.Valor})
        break;
        case '6':
          // console.log('En mixin dinamicos watch 6 newSelectValue', newSelectValue, typeof newSelectValue)
          // console.log('En mixin dinamicos watch 6  oldSelecValue',  oldSelecValue, typeof oldSelecValue)
          if( oldSelecValue !== null  ) {
            if( !oldSelecValue.hasOwnProperty('Detalle')  ) {
              // console.log('En mixin dinamicos watch 6 emit 1 Objeto.value',newSelectValue )
              this.$emit('input',
                  {
                    IdGrupo : this.idGrupo,
                    IdPregunta : this.idPregunta,
                    TextoRespuesta : '',
                    ValorRespuesta : '',
                    TipoPregunta : this.idTipoCampo,
                    Titulo : this.titulo,
                    Detalle : newSelectValue
                  }
                )

            } else {
              // console.log('En mixin dinamicos watch 6 emit 2 .detalle', oldSelecValue )
            
              this.$emit('input',
                  {
                    IdGrupo : this.idGrupo,
                    IdPregunta : this.idPregunta,
                    TextoRespuesta : '',
                    ValorRespuesta : '',
                    TipoPregunta : this.idTipoCampo,
                    Titulo : this.titulo,
                    Detalle : oldSelecValue.Detalle
                  }
                )
            }
          } else {
            // console.log('En mixin dinamicos watch 6 emit 3 newSelectValue',newSelectValue )

              this.$emit('input',
                  {
                    IdGrupo : this.idGrupo,
                    IdPregunta : this.idPregunta,
                    TextoRespuesta : '',
                    ValorRespuesta : '',
                    TipoPregunta : this.idTipoCampo,
                    Titulo : this.titulo,
                    Detalle : newSelectValue
                  }
                )

          }      
        break  
        case '3':
        case '12':
        case '14':
          this.$emit('input',
              {
                IdGrupo : this.idGrupo,
                IdPregunta : this.idPregunta,
                TextoRespuesta : '',
                ValorRespuesta : '',
                TipoPregunta : this.idTipoCampo,
                Titulo : this.titulo,
                Detalle : newSelectValue
              }
          )

        break;
        case '4':
          // como es un multi select y me llega un arreglo de los indices lo recooreo y construllo un nuevo arreglo
          newSelectValue.forEach( e =>
            aDetall.push({
                IdRespuesta : e,
                Respuesta : this.aOptions.find( elemento => elemento.ID == e).DatoMostrar
            })
          )
          this.$emit('input',
            {
              IdGrupo : this.idGrupo,
              IdPregunta : this.idPregunta,
              TextoRespuesta : '',
              ValorRespuesta : '',
              TipoPregunta : this.idTipoCampo,
              Titulo : this.titulo,
              Detalle : aDetall
            }
          )
        break;
        case '5':
            this.$emit('input',
            {
              IdGrupo : this.idGrupo,
              IdPregunta : this.idPregunta,
              TextoRespuesta : '',
              ValorRespuesta : newSelectValue ? "1" : "0",
              TipoPregunta : this.idTipoCampo,
              Titulo : this.titulo,
            }
          )
        break;
        default:
          if (newSelectValue !== null || newSelectValue !== undefined) {
            this.$emit('input',
              {
                IdGrupo : this.idGrupo,
                IdPregunta : this.idPregunta,
                TextoRespuesta : this.Texto,
                ValorRespuesta : this.Valor,
                TipoPregunta : this.idTipoCampo,
                Titulo : this.titulo,
              }
            )
          }
        break;
      }

    }
  }

}